import { IUserProfile } from '../../pages/UsersPage/constants'

export type formTypes =
  | 'memberRole'
  | 'memberPermission'
  | 'caseStatusMessage'
  | 'caseStatusMessage'
  | 'summary'
  | 'subjects'

export interface ICaseOverviewForm {
  [key: string]: string | any
}

export interface ITeamColumns {
  control: any
  removeUserFromTeam: (userId: number) => void
  previewOnly?: boolean
}

export enum reportPatchProperties {
  SUMMARY = 'summary',
  TIER_LEVEL = 'tier_level',
  ATTORNEY = 'attorney',
  NAME = 'name',
}

export interface ICaseStatusMessage {
  description: string
  created_at: string
  user_profile: IUserProfile
  id: number
}
